import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { choose } from "lit/directives/choose.js";
import { WarningLevel } from "../../../models";
import Fontawesome from "lit-fontawesome";

@customElement("ds-warning-icon")
export class WarningIcon extends BaseElement {
    static override styles = [
        Fontawesome,
        Style,
        css`
            :host {
                display: inline-block;
            }

            .Info {
                color: blue;
            }

            .Warning {
                color: orange;
            }

            .Danger {
                color: black;
            }
        `,
    ];
    @property({ type: String }) level: any;

    override render() {
        return html`
            ${choose(this.level, [
                [
                    WarningLevel.DANGER,
                    () =>
                        html`<i
                            class="fa fa-skull-crossbones ${this.level}"
                            aria-hidden="true"
                        ></i>`,
                ],
                [
                    WarningLevel.WARNING,
                    () =>
                        html`<i
                            class="fa fa-exclamation-triangle ${this.level}"
                            aria-hidden="true"
                        ></i>`,
                ],
                [
                    WarningLevel.INFO,
                    () => html`<i class="fa fa-info-circle ${this.level}" aria-hidden="true"></i>`,
                ],
            ])}
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-warning-icon": WarningIcon;
    }
}
